export default "__VITE_ASSET__DWe$jN97__"